<div v-bind:class="useClassName">
  <a
    @click="uploadOnPreview(propsData.code)"
    v-if="getAttribute('previewFile') && getAttribute('showRearrange')"
  >
    <!-- <div class="image-preview-tooltip-container"> -->
      <img :id="getId" :src="getAttribute('previewFile') + '?v=' + getUploadedFileUniqueVersion()" />
      <!-- <div class="image-preview-tooltip">{{getAttribute('uploadedFile')}}</div> -->
      <img class="hover-big-image" :src="getAttribute('previewFile') + '?v=' + getUploadedFileUniqueVersion()" />
    <!-- </div> -->
  </a>
  <a
    :data-fancybox="'gallery' + propsData.refId"
    :href="getAttribute('previewFileLink')"
    v-if="getAttribute('previewFile') && !getAttribute('showRearrange')"
  >
    <img :id="getId" :src="getAttribute('previewFile') + '?v=' + getUploadedFileUniqueVersion()" />
  </a>
 </div>